(function () {
  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function getProductSubtitle(product) {
    var handleText = normalize(product && product.handle);
    var titleText = normalize(product && product.title);
    var searchableText = `${handleText} ${titleText}`.trim();

    // Keep service-specific labels ahead of the generic "montaj hizmeti"
    // fallback. Several non-tyre services use handles that also contain
    // "montaj-hizmeti" (for example aku-* and mobil-*).
    if (searchableText.includes('nitrojen')) return 'Nitrojen Gaz Dolumu';
    if (searchableText.includes('depolama')) return 'Lastik Depolama';
    if (searchableText.includes('celik sibop')) return 'Çelik Sibop';
    if (searchableText.includes('plastik sibop')) return 'Plastik Sibop';
    if (searchableText.includes('sibop')) return 'Sibop Değişimi';
    if (searchableText.includes('onduzen') || searchableText.includes('on duzen')) return 'Öndüzen Ayarı';
    if (searchableText.includes('rot ayari') || searchableText.includes('rot balans')) return 'Rot Ayarı';
    if (searchableText.includes('tesla')) return 'Tesla Araç Montajı';
    if (
      handleText.includes('aku') ||
      titleText.includes('aku montaj') ||
      titleText.includes('aku hizmet') ||
      titleText.includes('aku degisim')
    ) return 'Akü Montajı';
    if (searchableText.includes('mobil montaj')) return 'Mobil Montaj Hizmeti';
    if (searchableText.includes('rft')) return 'RFT Lastik Montajı';
    if (searchableText.includes('hafif ticari')) return 'Hafif Ticari Lastik Montajı';
    if (searchableText.includes('4x4')) return '4x4 Lastik Montajı';
    if (
      searchableText.includes('lastik montaj') ||
      searchableText.includes('montaj hizmeti') ||
      searchableText.includes('lastik degisim') ||
      searchableText.includes('sokme takma')
    ) return 'Lastik Montajı';

    var productType = String((product && product.type) || '').trim();
    return productType && normalize(productType) !== 'hizmet' ? productType : '';
  }

  async function replaceExistingItems(options) {
    var cart = options.cart || {};
    var targetType = options.targetType || '';
    var getItemType = options.getItemType;
    var cleanNote = options.cleanNote;
    var nextNote = typeof options.note === 'string'
      ? options.note
      : cleanNote(cart.note || '', '', [targetType]);
    var items = Array.isArray(cart.items) ? cart.items : [];
    var queuedKeys = Array.isArray(cart._montajItemKeysToRemove) ? cart._montajItemKeysToRemove : [];
    var updates = {};

    items.forEach(function (item) {
      if ((getItemType(item) === targetType || queuedKeys.includes(item.key)) && item.key) updates[item.key] = 0;
    });

    if (!Object.keys(updates).length && nextNote === String(cart.note || '')) return cart;

    var response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, note: nextNote })
    });

    if (!response.ok) throw new Error('Sepetteki önceki montaj hizmeti kaldırılamadı.');

    return response.json();
  }

  async function rollbackAddedItem(itemKey, note) {
    if (!itemKey) return;

    var updates = {};
    updates[itemKey] = 0;
    var response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, note: String(note || '') })
    });

    if (!response.ok) throw new Error('Başarısız montaj işlemi geri alınamadı.');
  }

  window.KolayOtoMontajServiceContracts = {
    getProductSubtitle: getProductSubtitle,
    replaceExistingItems: replaceExistingItems,
    rollbackAddedItem: rollbackAddedItem
  };
})();
